module.exports = __webpack_public_path__ + "static/media/nfl.432995f2.png";